module.exports = __webpack_public_path__ + "static/media/cancel.5e3836ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/cancel.png
// module id = 71
// module chunks = 0